// extracted by mini-css-extract-plugin
export default {"container":"wx7UnSi5dh7EQEh_IG2c"};